import React from 'react';
import { Button, MessageBarActions, MessageBarBody } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { ErrorType } from '../../../models/HttpError';
import { GuideMessageBar } from '../../../theme/components/GuideMessageBar';
import { GuideSkeleton } from '../../../theme/components/GuideSkeleton';

interface WidgetDataProps {
  loading: boolean;
  failed: boolean;
  error?: ErrorType;
  onRetry: () => void;
  children: React.ReactNode;
  rows?: number;
}

/** Estados comunes de un widget con datos remotos: esqueleto mientras carga, banner con reintento si falla. */
export const WidgetData = ({ loading, failed, error, onRetry, children, rows = 4 }: WidgetDataProps) => {
  const { t } = useTranslation();
  if (loading) return <GuideSkeleton rows={rows} label={t('dashboard.common.loading')} data-testid="widget-loading" />;
  if (failed) {
    return (
      <GuideMessageBar intent="error" layout="multiline" data-testid="widget-error">
        <MessageBarBody>{error?.ErrorMessage || t('dashboard.common.error')}</MessageBarBody>
        <MessageBarActions>
          <Button size="small" onClick={onRetry}>
            {t('dashboard.common.retry')}
          </Button>
        </MessageBarActions>
      </GuideMessageBar>
    );
  }
  return <>{children}</>;
};

export default WidgetData;
